var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDirectionsIcon = function SvgDirectionsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m26.625 25.744-7.75 2.317-7.75-2.317-7.75 2.317V17.25l7.75-2.316 7.75 2.317 7.75-2.316v10.808Z",
    stroke: "#005DAB",
    strokeWidth: 1.383,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.057 17.56h.011M11.057 23.936h.011M11.057 20.748h.011M18.932 19.436h.011M18.932 25.81h.011M18.932 22.81h.011",
    stroke: "#239DFB",
    strokeWidth: 1.383,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.437 3.93a4.63 4.63 0 1 0 0 9.259 4.63 4.63 0 0 0 0-9.26Zm0-2.93a7.566 7.566 0 0 0-7.563 7.561c0 1.743.634 3.302 1.566 4.611l5.997 8.4 5.997-8.4C22.366 11.861 23 10.3 23 8.56A7.564 7.564 0 0 0 15.437 1Z",
    fill: "#005DAB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.437 5.704a2.856 2.856 0 1 0 .002 5.713 2.856 2.856 0 0 0-.002-5.713Z",
    fill: "#239DFB"
  })));
};
export default SvgDirectionsIcon;